import { BaseModel } from "model/BaseModel";
import HorarioItem from "./HorarioItem";

export default class Horario implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    tolerancia: number;
    itens: Array<HorarioItem>;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        tolerancia = 0,
        itens = new Array<HorarioItem>(),
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.tolerancia = tolerancia;
        this.itens = itens;
    }
}
